import Dailyreports from "./Dailyreports";
import Statements from "./Statements";
import Pigmyreports from "./Pigmyreports";
import Otherregister from "./Otherregister";
import Otherregister2 from "./Otherregister2";
import Customerreports from "./Customerreports";
import Depositreports from "./Depositreports";
import Bankinvestmentreport from "./Bankinvestmentreport";

import Rbireports from "./Rbireports"
import Glreports from "./Glreports";
import Loanreports from "./Loanreports";

import Agri from "./Agri";
import Banking from "./Banking";
import NonAgri from "./NonAgri";
import Transactions from "./Transactions";
import Investment from "./Investment";
import Transfer from "./Transfer";
import Statistics from "./Statistics";
import Stock from "./Stock";
import PayrollnHR from "./PayrollnHR";
import Shares from "./Shares";
import Branch from "./Branch";
//import branch_suggestion_status from "./branch_suggestion_status";
//import tgc report from "./tgc report";
export default {
  //tgc report,
  //branch_suggestion_status,
  ...Branch,
  ...Shares,
  ...PayrollnHR,
  ...Stock,
  ...Statistics,
  ...Transfer,
  ...Investment,
  ...Transactions,
  ...NonAgri,
  ...Banking,
  ...Agri,

  ...Dailyreports,
  ...Statements,
  ...Pigmyreports,
  ...Otherregister,
  ...Otherregister2,
  ...Customerreports,
  ...Depositreports,
  ...Bankinvestmentreport,
  ...Rbireports,
  ...Loanreports,
  ...Glreports,
}